var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-field form-field__hidden", class: _vm.rootClasses },
    [
      _c(
        "input",
        _vm._b({ attrs: { type: "hidden" } }, "input", _vm.inputAttrs, false)
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75159a16", { render: render, staticRenderFns: staticRenderFns })
  }
}